import z from 'zod';

export type Image = z.infer<typeof Image>;

export const Image = z.object({
  path: z.string(),
  width: z.number(),
  height: z.number(),
});
